/* eslint-disable no-unused-vars */
import { Link } from "react-router-dom";
import APP_URL, { LONG_NAME } from "../../../declaration/URL";
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import PageCard from "../../../components/Cards/PageCard";
import { useQuery } from "react-query";
import { instanceAxios } from "../../../app/axios";
import { PORTAL_UUID } from "../../../utils/constanst";
import { hasContractOption, systemuuid } from "../../../utils/systemuuid";
import PrimaryLabel from "../../../components/label/PrimaryLabel";

export const SettingCard = ({ to, label, state, className }) => {
  return (
    <Link to={to} state={state} className="inline-block">
      <div className=" text-bgHeader text-base font-semibold bg-[#D3E1F9] rounded-lg border border-[#BEDBFF] h-[90px] w-[300px] pl-4 flex items-center">
        {label}
      </div>
    </Link>
  );
};

function BukkenSetting() {
  const company_uuid = localStorage.getItem("uuidCompany");
  /**
   * システムデータ取得
   */
  const { data: systemData } = useQuery({
    queryKey: "BukkenSetting_GetSystemDataList",
    queryFn: async () => {
      const serverData = await instanceAxios.post("/user-manager/users/systems/get-contract/" + company_uuid);
      if (!serverData?.data?.data) {
        return [];
      }
      const sorted = serverData.data.data.toSorted((a, b) => {
        if (a.user_uuid == PORTAL_UUID) {
          return -1;
        }
        return a.user_uuid > b.user_uuid ? 1 : -1;
      });
      return sorted;
    },
    suspense: true
  });

  const uuids = systemData.map((item) => item.user_uuid);
  const hasPermissionForTakumi = uuids.includes("00000000-0000-0000-0000-000000010005");

  const crumbs = [{ to: LONG_NAME(APP_URL.bukken.bukkenSetting), title: "設定" }];

  const BukkenSettiingMenuLabel = () => {
    const isOptionContract = !hasContractOption(systemuuid.INVOICE) && !hasContractOption(systemuuid.QUOTATION);
    if (isOptionContract) return <></>;
    return (
      <div className="flex justify-between w-full mb-2">
        <PrimaryLabel
          title={"物件管理"}
          className="w-full pb-1"
          classNameTitle="!text-xl"
        />
      </div>
    );
  };

  const QuotationSettingMenu = () => {
    if (!hasContractOption(systemuuid.QUOTATION)) return <></>;
    return (
      <div className="bg-white mt-5">
        <div className="flex justify-between w-full mb-2">
          <PrimaryLabel
            title={"見積管理"}
            className="w-full pb-1"
            classNameTitle="!text-xl"
          />
        </div>
        <div className="flex flex-wrap gap-5 ml-3">
          <SettingCard to={LONG_NAME(APP_URL.quotation.quotationNumSetting)} label="見積書番号設定" />
          <SettingCard to={LONG_NAME(APP_URL.quotation.quotationReportSetting)} label="帳票出力設定" />
        </div>
      </div>
    );
  };

  const InvoiceSettingMenu = () => {
    if (!hasContractOption(systemuuid.INVOICE)) return <></>;
    return (
      <div className="bg-white mt-5">
        <div className="flex justify-between w-full mb-2">
          <PrimaryLabel
            title={"請求管理"}
            className="w-full pb-1"
            classNameTitle="!text-xl"
          />
        </div>
        <div className="flex flex-wrap gap-5 ml-3">
          <SettingCard to={LONG_NAME(APP_URL.invoice.invoiceNumSetting)} label="請求書番号設定" />
          <SettingCard to={LONG_NAME(APP_URL.invoice.invoiceReportSetting)} label="帳票出力設定" />
        </div>
      </div>
    );
  };

  return (
    <div className="w-full px-4 mb-2 h-[calc(100dvh-60px)] overflow-y-auto">
      <BreadCrumbs crumbs={[{ to: "", title: "設定" }]} />
      <PageCard outerClassName="!min-h-[calc(100dvh-95px)]">
        <div className="pb-10">
          <BukkenSettiingMenuLabel />
          <div className="flex flex-wrap gap-5 ml-3">
            <SettingCard to={LONG_NAME(APP_URL.bukken.bukkenNumSetting)} label="物件番号設定" />
            <SettingCard to={LONG_NAME(APP_URL.bukken.bukkenStatusMst)} label="進捗状況設定" />
            <SettingCard to={LONG_NAME(APP_URL.bukken.bukkenClassMst)} label="物件区分設定" />
            <SettingCard to={LONG_NAME(APP_URL.bukken.bukkenTabMst)} label="物件区分タブ設定" />
            <SettingCard to={LONG_NAME(APP_URL.bukken.bukkenItemMst)} label="物件区分タブ項目設定" />
            <SettingCard to={LONG_NAME(APP_URL.bukken.bukkenCommonMst)} label="物件区分共通フォルダ設定" />
            <SettingCard to={LONG_NAME(APP_URL.bukken.bukkenTemplateMst)} label="物件区分フォルダ設定" />
            {hasPermissionForTakumi && hasContractOption(systemuuid.TAKUMIPAD) && (
              <>
                <SettingCard to={LONG_NAME(APP_URL.bukken.bukkenDrawingMst)} label="物件区分図面フォルダ設定" />
                <SettingCard to={LONG_NAME(APP_URL.bukken.bukkenInspectionMst)} label="物件区分検査フォルダ設定" />
              </>
            )}
            <SettingCard to={LONG_NAME(APP_URL.bukken.constTypeMst)} label="物件区分写真フォルダ設定" />
            <SettingCard
              to={LONG_NAME(APP_URL.bukken.locationMst)}
              label="CAD地域設定"
              state={{ crumbs }}
              className="single-row"
            />
          </div>
        </div>
        <QuotationSettingMenu />
        <InvoiceSettingMenu />
      </PageCard>
    </div>
  );
}

export default BukkenSetting;
